import { createResource, type RouteResource } from 'react-resource-router';

import { assert, AssertionError } from '@atlassian/eoc-common';

import type { IncomingCallDetail } from '../../../common/types';
import { getDetail } from '../../endpoints/detail';

const detailResource: RouteResource<IncomingCallDetail> = createResource({
	type: 'getDetailResource',
	getKey: () => 'getDetailResource',
	getData: async (routerContext) => {
		const id = routerContext.match.params?.id;

		assert(
			!!id,
			new AssertionError('detailResource', 'id should be set to fetch incoming call detail'),
		);

		return getDetail(id);
	},
	isBrowserOnly: true,
});

export { detailResource };
